import React from 'react';
import CouponList from './components/CouponList';

const Coupon = ({ limit }) => {
  return (
    <div className="coupons">
      <CouponList limit={limit} />
    </div>
  );
};

export default Coupon;
